import { __rest } from "tslib";
import clsx from 'clsx';
import * as React from 'react';
const Table = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", { className: 'relative w-full overflow-auto' },
        React.createElement("table", Object.assign({ ref: ref, className: clsx('w-full caption-bottom text-sm', className) }, props))));
});
Table.displayName = 'Table';
const TableHeader = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("thead", Object.assign({ ref: ref, className: clsx('sticky top-0 z-10 border-solid border-base text-xs text-muted [&_tr]:border-b', className) }, props)));
});
TableHeader.displayName = 'TableHeader';
const TableBody = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("tbody", Object.assign({ ref: ref, className: clsx('border-solid border-base [&_tr:last-child]:border-0', className) }, props)));
});
TableBody.displayName = 'TableBody';
const TableFooter = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("tfoot", Object.assign({ ref: ref, className: clsx('border-t border-solid border-base bg-accent-3 font-medium [&>tr]:last:border-b-0', className) }, props)));
});
TableFooter.displayName = 'TableFooter';
const TableRow = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("tr", Object.assign({ ref: ref, className: clsx('border-b border-solid border-base transition-colors hover:bg-accent-3 data-[state=selected]:bg-accent-4', className) }, props)));
});
TableRow.displayName = 'TableRow';
const TableHead = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("th", Object.assign({ ref: ref, className: clsx('overflow-hidden border-b border-solid border-base bg-accent-3 px-3 py-2 text-left font-medium [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]', className) }, props)));
});
TableHead.displayName = 'TableHead';
const TableCell = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("td", Object.assign({ ref: ref, className: clsx('px-3 py-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]', className) }, props)));
});
TableCell.displayName = 'TableCell';
const TableCaption = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("caption", Object.assign({ ref: ref, className: clsx('text-muted-foreground mt-4 text-sm', className) }, props)));
});
TableCaption.displayName = 'TableCaption';
export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption, };
//# sourceMappingURL=index.js.map